import React from 'react';
import { CircleCheck, CircleMinus } from 'lucide-react';
import {
  DocumentIcon as HeroDocumentIcon,
  ArrowDownTrayIcon,
  CheckIcon as HeroCheckIcon,
  PrinterIcon,
  DocumentDuplicateIcon,
  XMarkIcon,
  ShoppingCartIcon,
  ShoppingBagIcon,
  PlusIcon as HeroPlusIcon,
  CubeIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';

/**
 * Ícono de documento genérico
 */
export const DocumentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <HeroDocumentIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de guardar (descargar)
 */
export const SaveIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <ArrowDownTrayIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de check / aprobar
 */
export const CheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <HeroCheckIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de imprimir
 */
export const PrintIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <PrinterIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de historial / auditoría (reloj)
 */
export const HistoryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <ClockIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de duplicar
 */
export const DuplicateIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <DocumentDuplicateIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de cancelar (X)
 */
export const XIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <XMarkIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de compras (carrito)
 */
export const PurchasesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <ShoppingCartIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de ventas (bolsa)
 */
export const SalesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <ShoppingBagIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de agregar (+)
 */
export const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <HeroPlusIcon {...props} aria-hidden="true" />
);

/**
 * Ícono de inventario (cubo)
 */
export const InventoryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <CubeIcon {...props} aria-hidden="true" />
);

/**
 * Iconos de la acción de ESTADO del documento, los MISMOS que usa MasterCrud para
 * «Desactivar registro» / «Activar registro» (lucide `CircleMinus` / `CircleCheck`).
 * Medido renderizado en `/app/items` el 2026-09-09: el check de «Activar» emite el
 * path `m9 12 2 2 4-4`, que es el de `CircleCheck`.
 */
export const DeactivateRecordIcon: React.FC<{ className?: string }> = ({ className }) => (
  <CircleMinus className={className} aria-hidden="true" />
);

export const ActivateRecordIcon: React.FC<{ className?: string }> = ({ className }) => (
  <CircleCheck className={className} aria-hidden="true" />
);
